.form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.card {
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 24px;
  background: var(--surface);
  border: var(--outline);
  border-radius: var(--radius-card);
  box-shadow: var(--shadow-card);
}

/* The published instructions keep their own paragraph breaks. */
.instructions {
  font-size: 14px;
  line-height: 1.5;
  color: var(--ink-2);
  white-space: pre-line;
}

/* The item is the screen's question, set smaller than a step's heading
 * because items can run to two lines. */
.card legend {
  font-size: 20px;
  font-weight: 600;
  line-height: 1.4;
}
